import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import assessmentService from "../../../store/services/assessment.service";
import {
  ASSESSMENT_CHANNEL_NAME,
  registerAssessmentEvent,
  registerAssessmentSocketConnected,
} from "../../../store/services/assessmentSocket.service";
import { MButton, MIconButton } from "../../../UI";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import classes from "./RollBackPopup.module.css";
import { useHistory } from "react-router-dom";
import { setShowAssessmentRollbackPopup } from "../../../store/actions/assessmentRollBack.action";

export default function RollBackPopup() {
  const { t } = useTranslation();
  const { assessmentId, showPopup } = useSelector((state) => {
    return {
      assessmentId: state.assessmentsReducer.assessmentdata.id,
      showPopup: state.assessmentRollBackReducer.showAssessmentRollbackPopup,
    };
  });
  const history = useHistory();
  const dispatch = useDispatch();

  const handleRollBack = (data) => {
    if (!assessmentId) {
      return;
    }

    if (data.id !== assessmentId) {
      return;
    }
    dispatch(setShowAssessmentRollbackPopup(true));
  };

  const handleAssessmentSocketConnected = () => {
    registerAssessmentEvent(
      ASSESSMENT_CHANNEL_NAME.ASSESSMENT_ROLL_BACK,
      handleRollBack
    );
  };

  const validateRollBacked = async () => {
    const { isRolledBack } = await assessmentService.isRolledBack(assessmentId);
    if (isRolledBack) {
      dispatch(setShowAssessmentRollbackPopup(true));
    }
  };

  useEffect(() => {
    if (!assessmentId) {
      return;
    }
    validateRollBacked();
    registerAssessmentSocketConnected(handleAssessmentSocketConnected);

  }, [assessmentId]);

  const handleClose = () => {
    history.push("/dashboard/assessments");
    dispatch(setShowAssessmentRollbackPopup(false));
  };

  return (
    <>
      <Dialog
        open={showPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            background: "rgba(0, 116, 228, 0.25)",
            display: "flex",
            flexDirection: "row-reverse",
            padding: "8px 24px 4px 24px",
          }}
        >
          <MIconButton onClick={handleClose}>
            <CloseIcon style={{ color: "#fff" }} />
          </MIconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ padding: "0 3vw" }}
          ></DialogContentText>
          <div className={classes.textContent}>
            <h1>This assessment is no longer available</h1>
            <span>
              Please contact the owner of this assessment for further details.
            </span>
          </div>
        </DialogContent>
        <DialogActions style={{ margin: "0 1vw 1vh 1vw" }}>
          {/* Cancel Button */}
          <div className={classes.okButton}>
            <MButton onClick={handleClose} variant="outlined">
              {t("OK")}
            </MButton>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
